<template>
  <div class="viewerCreate ">
          <br />
    <div class="seasoncast-card container">
    <h1>Viewer Create Account</h1>
     <p >Viewer accounts are required to get email notifications, create highlights, & to become a SeasonPass Holder</p>
     <hr />
      Already have a account? <a v-bind:href="'login' + ($route.query.return ? '?return='+$route.query.return :'')">[Switch to Account Login]</a>
     <br />
     <br />
     <p>Email:</p>
      <input v-model="email" type="email" class="form-control" aria-label="Text input with checkbox">
      <br />
      <p>Password:</p>
      <input  v-model="password" type="password" class="form-control" aria-label="Text input with checkbox"><br />
      
      <p>Confirm Password:</p>
      <input  v-model="passwordC" type="password" class="form-control" aria-label="Text input with checkbox"><br />
      
      <button  v-on:click="loginToViewer"  type="button"  class="btn btn-primary btn-block">Create Account</button>
   </div>
   </div>
</template>

<script>

  import Swal from "sweetalert2"
  import axios from "axios"
  import cookie from "cookie.js"

 let API = "https://app.seasoncast.com/"
export default {
          created: async function () {
    console.log("create call")
   let token =  cookie.get("viewer-token")
     let email =  cookie.get("viewer-email")

      if (token && email){ this.$router.push('/viewer/payment/'); }
        },
        data: function () {
    return {
      email: "",
      password: "",
      passwordC: "",
    }
  },
    methods:{
         loginToViewer: async function () {
             if (this.password != this.passwordC){
                  Swal.fire(
  'Create Error',
  'Reason: passwords are not the same',
  'error'
)
                 return
             }
             if (this.email.length < 5 || this.password.length < 5){
                        Swal.fire(
  'Create Error',
  'Reason: email or password is not long enough',
  'error'
)
                 return
             }
              let getEventResponse = await axios.post(API+ "v2/viewer/create", {
    email: this.email,
    password:  this.password
  }) 

    let responseData = getEventResponse.data
    console.log(responseData)

        if (!responseData.success){
  Swal.fire(
  'Create Error',
  'Reason: '+responseData.reason,
  'error'
)
return
         }
cookie.set("viewer-token",responseData.token, { path: '/' })
cookie.set("viewer-email",responseData.email, { path: '/' })
let callback = cookie.get("login_callback")
if (callback){
cookie.remove("login_callback")
this.$router.push(callback);
}else{
this.$router.push(this.$route.query.return ? this.$route.query.return : '/viewer/dashboard/');
}

         }
    }
}
    </script>
 